import { computePricingDetails } from '@epilot/journey-logic-commons'
import { useMemo } from 'react'

import { usePromoCodeValidationState } from '../../concorde-renderers/renderers/ShopCartControl/components/ShoppingCartPromoCode/hooks/usePromoCodeValidationState'

export const useComputePricingDetails = ({
  price,
  quantity = 1,
  overrides,
  externalCatalogData
}: Pick<
  Parameters<typeof computePricingDetails>[0],
  'price' | 'quantity' | 'overrides' | 'externalCatalogData'
>) => {
  const { redeemedPromos } = usePromoCodeValidationState()

  return useMemo(
    () =>
      computePricingDetails({
        price,
        quantity,
        overrides,
        externalCatalogData,
        redeemedPromos
      }),
    [price, quantity, overrides, externalCatalogData, redeemedPromos]
  )
}
